module.exports = __webpack_public_path__ + "img/Apk.df6f2239.svg";